import {getDataTypeJson} from '@/core/utils/getDataTypeJson';
import {formatDecimal} from '@/core/utils/formatDecimal';

/**
 * Transforms lookup values based on the provided configuration.
 *
 * @param {Array} data - The data to be transformed. This data is typically received from a request and is expected to be an array of objects.
 * Each object in the array represents a lookup item and may have different structures based on the configurations provided.
 * 
 * When `isDefaultLookups` is true, each object in the `data` array should have a `LookupItems` property, which is an array of items.
 * Each item in the `LookupItems` array should have `RecordGuid` and `Value` properties.
 * 
 * When `mdmConfig` is provided, each object in the `data` array should have `recordGuid` and `value` properties.
 *
 * @param {boolean} [isDefaultLookups=false] -The values that are obtained at the first rendering of the table or the values that are obtained from the query.
 * @param {Object|null} [mdmConfig=null] - The parameter is necessary to determine whether the data is of the ‘Decimal’ type and to get the ‘Scale’ value showing the number of digits after the point.
 * @returns {Array} The transformed lookup values.
 */
export const transformLookupValues = (data, isDefaultLookups = false, mdmConfig = null) => {

  if (isDefaultLookups) {
    return data
      .map(el => el.LookupItems.map(i => ({
        id: i.RecordGuid,
        text: i.Value,
      })))
      .flat(1)
      .sort((a, b) => a.text - b.text);
  }
  if (mdmConfig) {
    const parsedJson = getDataTypeJson(mdmConfig);
    const scale = parsedJson.Scale;
    const dataTypeName = parsedJson.UnderlyingDataType.split('.');
    const isDecimal = dataTypeName.includes('Decimal');
    return data
      .map(el => ({
        id: el.recordGuid,
        text: isDecimal && el.value 
          ? formatDecimal(el.value, scale).split(',').join('') 
          : el.value,
      }))
      .sort((a, b) => a.text - b.text);
  }
};